import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { LoginDto } from '@api/auth/interfaces';
import { select, Store } from '@ngrx/store';
import { getUser } from '@app/store/reducers';
import { UserState } from '@app/store/user/reducers';
import { Observable } from 'rxjs';
import { firstValueFrom } from '@app/util/rxjs-7-compat';
import { LoginDialogComponent } from '@app/components/elements/login-dialog/login-dialog.component';

@Injectable({
	providedIn: 'root',
})
export class InteractiveLoginService {
	private readonly activeUser$: Observable<UserState>;
	
	constructor(
		private readonly modalService: NzModalService,
		store: Store<never>,
	) {
		this.activeUser$ = store.pipe(select(getUser));
	}
	
	public async promptLogin(forceCurrentUser = true): Promise<LoginDto | null> {
		const activeUser = await firstValueFrom(this.activeUser$);
		
		const modalRef = this.modalService.create<LoginDialogComponent, LoginDto>({
			nzContent: LoginDialogComponent,
			nzComponentParams: {
				forceCurrentUser,
				result: { username: activeUser.username },
			},
			nzClosable: false,
		});
		
		const result = await firstValueFrom(modalRef.afterClose);
		
		return result ?? null;
	}
}
